export default __webpack_public_path__ + "static/media/paymentSchedules.3026ecb2.svg";